import * as React from 'react';
import { getPriceWithout } from '../../../helpers/Prices/getPrice';
var currencyFormatter = require('currency-formatter');

type PricesDisplayType = 'priceWithout' | 'recommendedPriceWithout';

interface IPricesDisplayPriceType {
  currencyId: string;
  priceWithout?: number;
}

interface IPricesDisplayProps {
  type: PricesDisplayType;
  amount?: number;
  prices: GQL.IPrice[] | null;
  currency?: GQL.ICurrency | null;
  className?: string;
}

class PricesDisplay extends React.Component<IPricesDisplayProps> {

  public render() {
    const { type, amount, currency, className } = this.props;

    const prices = this.props.prices
      ? this.props.prices.map((price: any) => {
          return {
            currencyId: price.currencyId,
            priceWithout: price[type],
          } as IPricesDisplayPriceType;
        })
      : [];

    if (amount !== undefined && amount !== null) {
      return (
        <span className={className}>
          {currency && !!currency.value
            ? currencyFormatter.format(amount, { code: currency.value })
            : amount}
        </span>
      );
    }

    if (!prices || !currency) {
      return null;
    }

    // další zadané ceny
    const otherPrices = prices.filter((price: IPricesDisplayPriceType) => !!price.priceWithout);

    return (
      <>
        <div>
          <strong>{getPriceWithout(prices, currency) || '-'} {currency.value || ''}</strong>
        </div>
        {otherPrices && otherPrices.length > 1 &&
          <>
            <small style={{ color: '#ff4d4f' }}>+ {otherPrices.length - 1} prices</small>
          </>}
      </>
    );
  }
}

export default PricesDisplay;


// WEBPACK FOOTER //
// ./src/components/Others/PricesDisplay/PricesDisplay.tsx